/**
 * Campo de tags: digita e confirma com Enter; cada tag sai pelo X.
 */
import { X } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Input } from '@/components/ui/input'

interface TagsInputProps {
  tags: string[]
  onAdd: (tag: string) => void
  onRemove: (tag: string) => void
  id?: string
  placeholder?: string
}

export function TagsInput({ tags, onAdd, onRemove, id, placeholder = 'Digite uma tag e pressione Enter' }: TagsInputProps) {
  return (
    <div className="flex flex-col gap-2">
      <Input
        id={id}
        type="text"
        aria-label={id ? undefined : 'Nova tag'}
        placeholder={placeholder}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            onAdd(e.currentTarget.value)
            e.currentTarget.value = ''
          }
        }}
      />
      {tags.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {tags.map((tag) => (
            <Badge key={tag} variant="secondary" className="pr-1">
              {tag}
              <button
                type="button"
                aria-label={`Remover tag ${tag}`}
                onClick={() => onRemove(tag)}
                className="rounded-full text-muted-foreground hover:text-foreground"
              >
                <X className="size-3" />
              </button>
            </Badge>
          ))}
        </div>
      )}
    </div>
  )
}
